import Gallery from './gallery'
import Calculator from './CalculatorStatic'

const ComponentList = {
  ContentfulGallery: Gallery,
  ContentfulCalculator: Calculator,
}

export default ComponentList
